import { Icon } from 'components'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { Typography } from '@mui/material'

function RequirementMetIndicator(_props) {
  const { condition = null, conditionStatus = false } = _props

  return (
    <div className="flex flex-row gap-2 items-center">
      <Typography
        variant="h5"
        component="div"
        className={conditionStatus ? 'text-success' : 'text-gray2'}
      >
        <Icon icon={faCircleCheck} />
      </Typography>
      <Typography variant="body1" component="div">
        {condition}
      </Typography>
    </div>
  )
}

export default RequirementMetIndicator
